export default "__VITE_ASSET__CGjCs34g__"